<template>
    <div v-if = 'this.$store.state.configs["ALLOW_LANGUAGES"] === true'>
        <label :for="'language' + randomID" class="hide-label">Language</label>
        <el-select class="language" :id="'language' + randomID" :name="'language' + randomID" @change="setLanguage" :value="selectedLanguage" value-key="value" placeholder="Select">
            <template slot="prefix"><i class="fa fa-globe language-icon prefix fa-1x" aria-hidden="true"> </i> </template>
            <el-option v-for="item in language" :key="item.value" :label="item.value" :value="item">
              <i class="fa fa-globe"></i>{{ item.value }} 
            </el-option>
        </el-select>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        language: [{
          value: 'EN'
        }, {
          value: 'ES'
        },
        {
          value: 'ZH'
        }],
        photo: 'static/lang.png'
      }
    },
    computed: {
      selectedLanguage () {
        const html = document.documentElement
        html.setAttribute('lang', this.$store.state.lang.value.toLowerCase())
        return this.$store.state.lang.value
      },
      randomID () {
        return Math.floor(Math.random() * 100)
      }
    },
    methods: {
      setLanguage (type) {
        this.$store.commit('setLang', type)
      }
    }
  }
</script>

<style lang="css" scoped>
  .language{
    width: 80px;
  }

  .prefix {
    margin-top: 10px;
  }

  .language-icon {
    color: #9a9a9a;
    font-size: 22px;
  }

  .hide-label{
    position: absolute !important;
    top: -9999px !important;
    left: -9999px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/LanguageButton.vue